module.exports = __webpack_public_path__ + "static/media/icon-dev-ic-clear.37aa0e71.svg";